import regexForm from '../../utils/regexForm';

const {
    country,
    email,
    firstname,
    lastname,
    organisationName,
    password,
    phone,
    url,
} = regexForm;

const subscriptionInputsPatterns = [
    {
        name: 'organisationName',
        pattern: organisationName,
        type: 'text',
        required: true,
    },
    {
        name: 'lastname',
        pattern: lastname,
        type: 'text',
        required: true,
    },
    {
        name: 'firstname',
        pattern: firstname,
        type: 'text',
        required: true,
    },
    {
        name: 'email',
        pattern: email,
        type: 'email',
        required: true,
    },
    {
        name: 'phone',
        pattern: phone,
        type: 'tel',
        required: true,
    },
    {
        name: 'password',
        pattern: password,
        type: 'password',
        required: true,
    },
    {
        name: 'passwordVerify',
        pattern: password,
        type: 'password',
        required: true,
    },
    {
        name: 'country',
        pattern: country,
        type: 'text',
        required: true,
    },
    {
        name: 'organisationWebsite',
        pattern: url,
        type: 'url',
        required: false,
    },
];

export { subscriptionInputsPatterns };
